export const CicEarlierReasonColumnId = {
  REASON: 'reason',
  FIELDS: 'fields',
  COMMENT: 'comment',
  ADDED_BY: 'addedBy',
};
